import {useEffect, useState} from "react";
import CustomLoader from "../../CustomComponents/CustomLoader";

import {useLocation} from "react-router-dom";
import {GetCommentHistoryService} from "../../services/contractorServices";

import Modal from "@mui/material/Modal";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

import Rating from "@mui/material/Rating";
import CustomUserName from "../../CustomComponents/CustomUserName";
import {fDate} from "../../utils/format-time";
import {truncateWords} from "../../utils/format-text";
import {Flex} from "antd";
import {CommentRepliesService, deleteAddressStreetZip} from "../../services/adminServices";
import CustomPagination from "../../CustomComponents/CustomPagination";
import {sweetAlertQuestion, sweetAlerts} from "../../utils/sweet-alerts";

const Replies = () => {
	const location = useLocation();

	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecode, setTotalRecode] = useState(0);
	const [loadingButtons, setLoadingButtons] = useState({});

	const [loading, setLoading] = useState(true);
	const [list, setList] = useState([]);

	const getMockRatings = async () => {
		try {
			setLoading(true);
			const response = await CommentRepliesService({page: page, page_size: pageSize});

			if (response?.status) {
				setList(response?.data?.list);
				setTotalRecode(response?.data?.totalRecords);
			}
		} catch (error) {
			console.error("Error fetching item list:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getMockRatings();
	}, [page, pageSize]);

	// Format date and time
	const formatDateTime = (dateString) => {
		return new Date(dateString).toLocaleString("en-US", {
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});
	};

	const handleDeleteComment = async (commentId) => {
		sweetAlertQuestion("Are you sure you want to delete this comment? This action cannot be undone.").then(async (result) => {
			if (result === "Yes") {
				setLoadingButtons((prev) => ({...prev, [`delete-${commentId}`]: true}));
				try {
					// In real app, this would be an API call like: const response = await deleteComment(commentId);

					// Simulate API call
					await new Promise((resolve) => setTimeout(resolve, 500));

					const response = await deleteAddressStreetZip(commentId);
					if (response && response.status === true) {
						getMockRatings();
						sweetAlerts("success", "Comment deleted successfully");
					} else {
						sweetAlerts("error", "Failed deleting rating. Please try again.");
					}
				} catch (error) {
					console.error("Error deleting comment:", error);
					sweetAlerts("error", "Failed deleting comment. Please try again.");
				} finally {
					setLoadingButtons((prev) => ({...prev, [`delete-${commentId}`]: false}));
				}
			}
		});
	};
	return (
		<div className="dashboard-page">
			<div className="page-header">
				<h2>Comment Replies</h2>
			</div>

			<div className="bg-white p-4">
				{loading ? (
					<div className="ratings-container">
						<CustomLoader />
					</div>
				) : (
					<div className="">
						{list && list?.length > 0 ? (
							list?.map((item, index) => {
								return (
									<div key={index} className="mb-2 rating-card p-3">
										<div className="border-success border-2  bg-light">
											<div className="py-3">
												<div className="row align-items-center pb-2 border-bottom">
													<div className="col-md-9">
														<div className="mb-2">
															<strong>{item?.title}</strong>
														</div>
														<div className="text-muted">{item?.description || "No description provided"}</div>
													</div>
													<div className="col-md-3">
														<div className="text-end">
															<div className="text-muted small mb-1">Job Date: {fDate(item?.comment_date)}</div>
															<div className="d-flex justify-content-end ">
																<CustomUserName user={item?.user} sx={{fontSize: 14, fontWeight: 600}} />
															</div>
															<div className="mt-1">
																<Chip label={`${item?.street_comments?.length || 0} Comment`} size="small" color="info" />
															</div>
														</div>
													</div>
												</div>

												{item?.likes && item?.likes?.length > 0 && (
													<div className="">
														<div className="likes-list">
															{item.likes?.map((like, likeIndex) => (
																<div key={likeIndex} className="d-flex align-items-center py-1 px-2 mb-1 bg-light rounded">
																	<div className="me-2">
																		<Avatar variant="rounded" sx={{bgcolor: "#22c55e1a", color: "#28a745"}}>
																			<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<path
																					d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.351 11.8792 21.7564 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22249 22.4518 8.5C22.4518 7.77751 22.3095 7.0621 22.0329 6.39464C21.7564 5.72718 21.351 5.12075 20.84 4.61Z"
																					stroke="currentColor"
																					strokeWidth="2"
																					strokeLinecap="round"
																					strokeLinejoin="round"
																				/>
																			</svg>
																		</Avatar>
																	</div>
																	<div className="flex-grow-1">
																		<div className="fw-semibold small">
																			<CustomUserName user={like?.user} sx={{fontWeight: 600}} />
																		</div>
																		<div className="text-muted" style={{fontSize: "0.65rem"}}>
																			{formatDateTime(like?.createdAt)}
																		</div>
																	</div>
																</div>
															))}
														</div>
													</div>
												)}

												{item.street_comments?.map((comments, likeIndex) => (
													<div key={likeIndex} className="d-flex align-items-center py-1 px-2 mb-1 bg-light rounded">
														<div className="me-2">
															<Avatar variant="rounded" sx={{bgcolor: "#0dcaf01a", color: "#0dcaf0"}}>
																<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																</svg>
															</Avatar>
														</div>
														<div className="flex-grow-1">
															<div className="fw-semibold small">
																<CustomUserName user={comments?.user} sx={{fontWeight: 600}} />
															</div>

															<div className="text-muted" style={{fontSize: "0.65rem"}}>
																{formatDateTime(comments?.createdAt)}
															</div>

															{comments?.description}
														</div>

														{/* <button className="btn-icon btn-delete" title="Delete Comment">
															<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
																<path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																<path
																	d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
																	stroke="currentColor"
																	strokeWidth="2"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																/>
															</svg>
														</button> */}

														{console.log("comments", comments)}

														<button className="btn-icon btn-delete" onClick={() => handleDeleteComment(comments?.street_id)} title="Delete Comment" disabled={loadingButtons[`delete-${comments.id}`]}>
															{loadingButtons[`delete-${comments?.street_id}`] ? (
																<span className="spinner-small"></span>
															) : (
																<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
																	<path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path
																		d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
																		stroke="currentColor"
																		strokeWidth="2"
																		strokeLinecap="round"
																		strokeLinejoin="round"
																	/>
																</svg>
															)}
														</button>
													</div>
												))}
											</div>
										</div>
									</div>
								);
							})
						) : (
							<div className="text-center py-5">
								<div className="text-muted">No Comment Replies found</div>
							</div>
						)}

						{!loading && (
							<CustomPagination
								current={page}
								pageSize={pageSize}
								total={totalRecode}
								onChange={(e) => setPage(e)}
								scroll={{x: "max-content", y: 10 * 5}}
								onShowSizeChange={(p, e) => {
									setPage(p);
									setPageSize(e);
								}}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default Replies;
